import {
    GridSortCellParams,
    gridStringOrNumberComparator,
} from "@mui/x-data-grid-premium";

export const singleSelectSortComparator = (
    v1: string,
    v2: string,
    param1: GridSortCellParams<any>,
    param2: GridSortCellParams<any>,
    options: { value: string; label: string; sortLabel?: string }[]
) => {
    const o1 = options.find((o) => o.value === v1);
    const o2 = options.find((o) => o.value === v2);

    // NULLs last when ascending order
    if (!o1) return 1;
    if (!o2) return -1;

    const result = gridStringOrNumberComparator(
        o1.sortLabel ?? o1.label, // Use sortlabel, fallback to label
        o2.sortLabel ?? o2.label, // Use sortlabel, fallback to label
        param1,
        param2
    );

    return result;
};

export const stringOrNumberSortComparator = (
    v1: string | number,
    v2: string | number,
    param1: GridSortCellParams<any>,
    param2: GridSortCellParams<any>
) => {
    // NULLs last when ascending order
    if (!v1 && v1 !== 0) return 1;
    if (!v2 && v2 !== 0) return -1;

    const result = gridStringOrNumberComparator(v1, v2, param1, param2);

    return result;
};
